window.theme = window.theme || {};
var THMHelper = window.BEYHelper || {};
THMHelper.qs = document.querySelector.bind(document);
THMHelper.qsa = document.querySelectorAll.bind(document);
THMHelper.qid = document.getElementById.bind(document);
THMHelper.qde = document.documentElement;


/* ---------------------------------------------------------------------------
 * THMDom - small vanilla-JS helpers that replace the jQuery APIs this theme
 * used to depend on (selection, delegation, slide/fade effects, animated
 * scrolling, offsets and section-HTML replacement).
 * ------------------------------------------------------------------------- */
var THMDom = (function () {
  // jQuery's default "swing" easing.
  function swing(progress) {
    return 0.5 - Math.cos(progress * Math.PI) / 2;
  }

  function toList(value) {
    if (!value) return [];
    if (value.nodeType) return [value];
    return Array.prototype.slice.call(value);
  }

  function qsa(selector, context) {
    try {
      return Array.prototype.slice.call(
        (context || document).querySelectorAll(selector)
      );
    } catch (error) {
      return [];
    }
  }

  function qs(selector, context) {
    try {
      return (context || document).querySelector(selector);
    } catch (error) {
      return null;
    }
  }

  function ready(callback) {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", callback);
    } else {
      window.setTimeout(callback, 0);
    }
  }

  // Delegated listener, equivalent to $(document).on(type, selector, handler).
  function on(type, selector, handler, root) {
    var scope = root || document;
    scope.addEventListener(type, function (event) {
      var origin = event.target;
      if (!origin || !origin.closest) return;
      var match = origin.closest(selector);
      if (!match || !scope.contains(match)) return;
      handler.call(match, event);
    });
  }

  function addClass(elements, className) {
    toList(elements).forEach(function (el) {
      el.classList.add(className);
    });
  }

  function removeClass(elements, className) {
    toList(elements).forEach(function (el) {
      el.classList.remove(className);
    });
  }

  function removeAttr(elements, name) {
    toList(elements).forEach(function (el) {
      el.removeAttribute(name);
    });
  }

  function text(elements, value) {
    toList(elements).forEach(function (el) {
      el.textContent = value;
    });
  }

  // $(window).width()
  function windowWidth() {
    return document.documentElement.clientWidth;
  }

  // $(selector).val() - undefined when nothing matches, like jQuery.
  function val(selector) {
    var el = qs(selector);
    return el ? el.value : undefined;
  }

  // $(el).offset().top
  function offsetTop(el) {
    if (!el) return 0;
    var rect = el.getBoundingClientRect();
    return rect.top + (window.pageYOffset || document.documentElement.scrollTop);
  }

  // $(el).position().top
  function positionTop(el) {
    if (!el) return 0;
    var offsetParent = el.offsetParent;
    var parentTop = 0;
    if (offsetParent && offsetParent.nodeName !== "HTML") {
      parentTop =
        offsetTop(offsetParent) +
        (parseFloat(window.getComputedStyle(offsetParent).borderTopWidth) || 0);
    }
    return (
      offsetTop(el) -
      parentTop -
      (parseFloat(window.getComputedStyle(el).marginTop) || 0)
    );
  }

  function siblings(el, selector) {
    if (!el || !el.parentNode) return [];
    return Array.prototype.filter.call(el.parentNode.children, function (child) {
      return child !== el && (!selector || child.matches(selector));
    });
  }

  // $(set).is(node)
  function is(elements, target) {
    return toList(elements).indexOf(target) !== -1;
  }

  // $(set).has(node)
  function has(elements, target) {
    return toList(elements).filter(function (el) {
      return el !== target && el.contains(target);
    });
  }

  // $(htmlString) - returns a detached document to query against.
  function parseHTML(html) {
    return new DOMParser().parseFromString(html, "text/html");
  }

  // $(sel).replaceWith($(sel, parsed))
  function replaceFrom(selector, parsed) {
    var current = qs(selector);
    if (!current) return;
    var replacement = parsed ? qs(selector, parsed) : null;
    if (replacement) {
      current.parentNode.replaceChild(
        document.importNode(replacement, true),
        current
      );
    } else {
      // jQuery removes the node when the replacement set is empty.
      if (current.parentNode) current.parentNode.removeChild(current);
    }
  }

  function isHidden(el) {
    return !(el.offsetWidth || el.offsetHeight || el.getClientRects().length);
  }

  /* ---------------------------------------------------------------------
   * Effects
   * ------------------------------------------------------------------- */
  var BOX_PROPS = [
    "height",
    "paddingTop",
    "paddingBottom",
    "marginTop",
    "marginBottom",
  ];

  function stopAnim(el) {
    if (el.__thmAnimFrame) {
      window.cancelAnimationFrame(el.__thmAnimFrame);
      el.__thmAnimFrame = null;
    }
  }

  function animate(el, from, to, duration, apply, complete) {
    stopAnim(el);
    var startTime = null;
    function step(now) {
      if (startTime === null) startTime = now;
      var progress = duration > 0 ? Math.min((now - startTime) / duration, 1) : 1;
      apply(from, to, swing(progress));
      if (progress < 1) {
        el.__thmAnimFrame = window.requestAnimationFrame(step);
      } else {
        el.__thmAnimFrame = null;
        if (complete) complete();
      }
    }
    el.__thmAnimFrame = window.requestAnimationFrame(step);
  }

  function clearBoxStyles(el) {
    el.style.removeProperty("height");
    el.style.removeProperty("padding-top");
    el.style.removeProperty("padding-bottom");
    el.style.removeProperty("margin-top");
    el.style.removeProperty("margin-bottom");
    el.style.removeProperty("overflow");
  }

  function readBox(el) {
    var computed = window.getComputedStyle(el);
    return {
      height: parseFloat(computed.height) || 0,
      paddingTop: parseFloat(computed.paddingTop) || 0,
      paddingBottom: parseFloat(computed.paddingBottom) || 0,
      marginTop: parseFloat(computed.marginTop) || 0,
      marginBottom: parseFloat(computed.marginBottom) || 0,
    };
  }

  var ZERO_BOX = {
    height: 0,
    paddingTop: 0,
    paddingBottom: 0,
    marginTop: 0,
    marginBottom: 0,
  };

  function applyBox(el, from, to, eased) {
    BOX_PROPS.forEach(function (prop) {
      el.style[prop] = from[prop] + (to[prop] - from[prop]) * eased + "px";
    });
  }

  function slideUp(el, duration) {
    if (!el) return;
    stopAnim(el);
    if (isHidden(el)) return;
    var from = readBox(el);
    el.style.overflow = "hidden";
    animate(
      el,
      from,
      ZERO_BOX,
      duration === undefined ? 400 : duration,
      function (f, t, eased) {
        applyBox(el, f, t, eased);
      },
      function () {
        clearBoxStyles(el);
        el.style.display = "none";
      }
    );
  }

  function slideDown(el, duration) {
    if (!el) return;
    stopAnim(el);
    clearBoxStyles(el);
    el.style.removeProperty("display");
    if (window.getComputedStyle(el).display === "none") {
      el.style.display = "block";
    }
    var to = readBox(el);
    el.style.overflow = "hidden";
    applyBox(el, ZERO_BOX, to, 0);
    animate(
      el,
      ZERO_BOX,
      to,
      duration === undefined ? 400 : duration,
      function (f, t, eased) {
        applyBox(el, f, t, eased);
      },
      function () {
        clearBoxStyles(el);
      }
    );
  }

  function slideToggle(el, duration) {
    if (!el) return;
    if (isHidden(el)) {
      slideDown(el, duration);
    } else {
      slideUp(el, duration);
    }
  }

  function fadeIn(el, duration) {
    if (!el) return;
    stopAnim(el);
    var hidden = window.getComputedStyle(el).display === "none";
    if (hidden) {
      el.style.removeProperty("display");
      if (window.getComputedStyle(el).display === "none") {
        el.style.display = "block";
      }
    }
    var from = hidden ? 0 : parseFloat(window.getComputedStyle(el).opacity) || 0;
    el.style.opacity = from;
    animate(
      el,
      from,
      1,
      duration === undefined ? 400 : duration,
      function (f, t, eased) {
        el.style.opacity = f + (t - f) * eased;
      },
      function () {
        el.style.removeProperty("opacity");
      }
    );
  }

  function hide(elements) {
    toList(elements).forEach(function (el) {
      el.style.display = "none";
    });
  }

  // $("html, body").animate({ scrollTop: value }, duration, complete)
  function scrollTopTo(value, duration, complete) {
    var start = window.pageYOffset || document.documentElement.scrollTop;
    var max = Math.max(
      document.documentElement.scrollHeight -
        document.documentElement.clientHeight,
      0
    );
    var end = Math.max(0, Math.min(value, max));
    duration = duration === undefined ? 400 : duration;

    if (start === end || duration <= 0) {
      window.scrollTo(0, end);
      if (complete) complete();
      return;
    }

    var startTime = null;
    function step(now) {
      if (startTime === null) startTime = now;
      var progress = Math.min((now - startTime) / duration, 1);
      window.scrollTo(0, start + (end - start) * swing(progress));
      if (progress < 1) {
        window.requestAnimationFrame(step);
      } else if (complete) {
        complete();
      }
    }
    window.requestAnimationFrame(step);
  }

  return {
    qs: qs,
    qsa: qsa,
    ready: ready,
    on: on,
    addClass: addClass,
    removeClass: removeClass,
    removeAttr: removeAttr,
    text: text,
    windowWidth: windowWidth,
    val: val,
    offsetTop: offsetTop,
    positionTop: positionTop,
    siblings: siblings,
    is: is,
    has: has,
    parseHTML: parseHTML,
    replaceFrom: replaceFrom,
    isHidden: isHidden,
    slideUp: slideUp,
    slideDown: slideDown,
    slideToggle: slideToggle,
    fadeIn: fadeIn,
    hide: hide,
    scrollTopTo: scrollTopTo,
  };
})();


(function () {
  "use strict";
  var Echo = {
    init: function () {
      this.Basic.init();
    },

    Basic: {
      init: function () {
        this.smoothScroll();

        this.announcementBar();
        this.marqueeScroller();
      },

      smoothScroll: function () {
        THMDom.qsa('a[href*="#"]')
          .filter(function (link) {
            var href = link.getAttribute("href");
            return href !== "#" && href !== "#0";
          })
          .forEach(function (link) {
            link.addEventListener("click", function (event) {
              // On-page links
              if (
                location.pathname.replace(/^\//, "") ==
                this.pathname.replace(/^\//, "") &&
                location.hostname == this.hostname
              ) {
                // Figure out element to scroll to
                var target = this.hash ? THMDom.qsa(this.hash) : [];
                target = target.length
                  ? target
                  : THMDom.qsa("[name=" + this.hash.slice(1) + "]");
                // Does a scroll target exist?
                if (target.length) {
                  // Only prevent default if animation is actually gonna happen
                  event.preventDefault();
                  THMDom.removeAttr(
                    THMDom.qsa(".menu-drawer-container"),
                    "open"
                  );
                  THMDom.qsa(".menu-drawer-container summary").forEach(
                    function (summary) {
                      summary.setAttribute("aria-expanded", false);
                    }
                  );
                  document.body.classList.remove("overflow-hidden-tablet");
                  THMDom.scrollTopTo(
                    THMDom.offsetTop(target[0]),
                    600,
                    function () {
                      // Callback after animation
                      // Must change focus!
                      var focusTarget = target[0];
                      focusTarget.focus();
                      if (document.activeElement === focusTarget) {
                        // Checking if the target was focused
                        return false;
                      } else {
                        focusTarget.setAttribute("tabindex", "-1"); // Adding tabindex for elements not focusable
                        focusTarget.focus(); // Set focus again
                      }
                    }
                  );
                }
              }
            });
          });
      },

      announcementBar: function () {
        class AnnouncementBar extends HTMLElement {
          constructor() {
            super();

            this.sessionStorageKey = "announcementBarClosed";
            this.closeButton = this.querySelector("[data-close-button]");
            this.closeButton &&
              this.closeButton.addEventListener(
                "click",
                this.onClose.bind(this)
              );
          }

          connectedCallback() {
            if (sessionStorage.getItem(this.sessionStorageKey)) return;
            this.classList.remove("hidden");
            this.initSlider();
          }

          initSlider() {
            if (!this.querySelector(".swiper")) return;
            if (typeof Swiper === "undefined") return;

            this.options = {
              slidesPerPage: 1,
              effect: "fade",
              rewind: true,
              draggable: true,
            };

            if (this.dataset.sliderType !== "controls") {
              this.options.autoplay = {
                delay: 6000,
              };
            } else {
              this.options.navigation = {
                prevEl: "[data-arrow-prev]",
                nextEl: "[data-arrow-next]",
              };
            }

            this.slider = new Swiper(
              this.querySelector(".swiper"),
              this.options
            );
          }

          onClose() {
            this.classList.add("hidden");
            sessionStorage.setItem(this.sessionStorageKey, true);
          }
        }

        customElements.define("announcement-bar", AnnouncementBar);
      },
      marqueeScroller: function () {
        if (!customElements.get("marquee-content")) {
          class EchoMarquee extends HTMLElement {
            constructor() {
              super();
            }
            connectedCallback() {
              this.init();
            }
            calculationPaddingSection() {
              (this.heightSection = this.offsetHeight),
                (this.heightSection =
                  this.heightSection < 18
                    ? 18
                    : 96 < this.heightSection
                      ? 96
                      : this.heightSection),
                this.closest(".js-running-content").style.setProperty(
                  "--spacing-padding-block",
                  this.heightSection + "px"
                );
            }
            init() {
              (this.distance =
                this.querySelector(".js-marquee-item").offsetWidth),
                (this.speed = this.dataset.speed),
                this.style.setProperty(
                  "--marquee-duration",
                  this.distance / this.speed + "s"
                );
            }
          }
          customElements.define("marquee-content", EchoMarquee);
        }
      },
    },
  };

  THMDom.ready(function () {
    Echo.init();
  });
})();


var ECHelper = window.ECHelper || {};
ECHelper.qs = document.querySelector.bind(document);
ECHelper.qsa = document.querySelectorAll.bind(document);
ECHelper.qid = document.getElementById.bind(document);
ECHelper.qde = document.documentElement;

class EHCLazyLoadingVideo extends HTMLElement {
  constructor() {
    super(),
      (this.iframe = this.querySelector("iframe")),
      (this.template = this.querySelector("template")),
      (this.isMouseenter = !1);
  }
  loadVideo() {
    var t;
    this.iframe &&
      (this.iframe.setAttribute("src", this.iframe.getAttribute("data-src")),
        this.iframe.addEventListener(
          "load",
          function () {
            "youtube" == this.dataVideoType &&
              this.iframe.contentWindow.postMessage(
                '{"event":"command","func":"playVideo","args":""}',
                "*"
              ),
              "vimeo" == this.dataVideoType &&
              this.iframe.contentWindow.postMessage('{"method":"play"}', "*");
          }.bind(this)
        )),
      "local_video" == this.dataVideoType &&
      ((this.local_video = this.querySelector("video")),
        (t = this.local_video.querySelector("source").getAttribute("data-src")),
        (this.local_video.src = t));
  }
  execute() {
    Shopify.designMode
      ? this.loadVideo()
      : (["mousemove", "touchstart"].forEach(
        function (t) {
          ECHelper.qs("body").addEventListener(
            t,
            function (t) {
              this.isMouseenter || this.loadVideo(), (this.isMouseenter = !0);
            }.bind(this),
            { once: !0 }
          );
        }.bind(this)
      ),
        window.addEventListener(
          "scroll",
          function (t) {
            this.isMouseenter || this.loadVideo(), (this.isMouseenter = !0);
          }.bind(this),
          { once: !0 }
        ));
  }
  static get observedAttributes() {
    return ["data-video-type", "data-video-id"];
  }
  set dataVideoType(t) {
    this.setAttribute("data-video-type", t);
  }
  get dataVideoType() {
    return this.getAttribute("data-video-type");
  }
  set dataVideoId(t) {
    this.setAttribute("data-video-id", t);
  }
  get dataVideoId() {
    return this.getAttribute("data-video-id");
  }
  attributeChangedCallback(t, e, s) {
    e !== s && this.execute();
  }
  connectedCallback() {
    this.execute();
  }
  disconnectedCallback() { }
}
customElements.define("echo-load-video", EHCLazyLoadingVideo);

class collapsebleComponent extends HTMLElement {
  constructor() {
    super();

    this.collapseble__button = THMDom.qsa(".collapseble__tiem", this);
    this.collapseble__content = THMDom.qsa(".collapseble__content", this);
  }

  connectedCallback() {
    this.collapseble__button.forEach(function (button) {
      button.addEventListener("click", function () {
        if (!this.classList.contains("active")) {
          THMDom.qsa(".collapseble__content").forEach(function (content) {
            THMDom.slideUp(content);
          });
          THMDom.removeClass(THMDom.qsa(".collapseble__tiem"), "active");
          THMDom.qsa(".collapseble__content", this).forEach(function (content) {
            THMDom.slideToggle(content);
          });
          this.classList.toggle("active");
        } else {
          THMDom.qsa(".collapseble__content", this).forEach(function (content) {
            THMDom.slideUp(content);
          });
          this.classList.remove("active");
        }
      });
    });
  }
}
customElements.define("collapseble-component", collapsebleComponent);










THMDom.on("click", "button.button__accordian", function (e) {
  THMDom.siblings(this, '.accordian_content_wrap').forEach(function (content) {
    THMDom.slideToggle(content);
  });
  this.classList.toggle('active');
});

THMDom.on("click", "button.apply-discount-code", function (e) {
  const discountWrapper = this.closest('.cart-discount');
  const discountInput = discountWrapper
    ? discountWrapper.querySelector('[name="discount"]')
    : null;
  const discountCode = discountInput ? discountInput.value : undefined;
  var btn = this;
  // console.log("Tress", discountCode);

  if (discountCode) {
    btn.classList.add('btn--loading');
    document.cookie = `discount_code=${discountCode}; path=/`;
    fetch(`/discount/${discountCode}`)
      .then(function () {

        return fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            updates: {},
          }),
        });
      })
      .then(function (data) {
        // Full drawer re-render so line prices, rewards bar and totals all update.
        const cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer && typeof cartDrawer.refresh === 'function') {
          return cartDrawer.refresh().finally(function () {
            btn.classList.remove('btn--loading');
          });
        }

        fetch('?section_id=cart-drawer')
          .then((response) => response.text())
          .then((cartData) => {
            btn.classList.remove('btn--loading');
            var cart_html = THMDom.parseHTML(cartData);
            THMDom.replaceFrom('#CartDrawer-CartItems', cart_html);
            THMDom.replaceFrom('#cart_summary_updated', cart_html);

          });
      })
      .catch(function (error) {
        console.error('Error:', error);
      });


  }

});




var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = "${{amount_no_decimals}}";
Shopify.formatMoney = function (cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.', ''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
    return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split('.'),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
      cents = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};



class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.updateVariantInput();
    this.updatePrice();
    this.updateImage();
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });


    this.toggleAddButton(!this.currentVariant.available, "Sold Out");

  }


  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updatePrice() {
    const productPrice = this.offsetParent.querySelector(`#upsell-price-${this.dataset.section}`);
    productPrice.innerHTML = "add to cart - " + Shopify.formatMoney(this.currentVariant.price, window.theme.moneyFormat);

  }


  updateImage() {
    const upsellImage = this.offsetParent.querySelector(`#upsell-image-${this.dataset.section}`);
    if (this.currentVariant.featured_image != null) {
      upsellImage.querySelector('img').src = this.currentVariant.featured_image.src
      upsellImage.querySelector('img').srcset = this.currentVariant.featured_image.src
      upsellImage.querySelector('img').setAttribute("data-src", this.currentVariant.featured_image.src);
    }

  }

  updateVariantInput() {


    const productForms = document.querySelectorAll(`#Card-Drawer-Upsell-Form-${this.dataset.section}`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      // input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }



  toggleAddButton(disable = true, text, modifyClass = true) {


    const productForm = this.offsetParent.querySelector(`#Card-Drawer-Upsell-Form-${this.dataset.section}`);

    const productPrice = this.offsetParent.querySelector(`#upsell-price-${this.dataset.section}`);


    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"]  span.js-product-form-submit-btn-text');

    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = "add to cart - " + Shopify.formatMoney(this.currentVariant.price, window.theme.moneyFormat);
    }

    if (!modifyClass) return;




  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }

}
customElements.define('variant-selects', VariantSelects);


class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);





THMDom.on("click", ".js-quantity-selector-toggle", function (e) {
  e.preventDefault();
  THMDom.qsa('.js-quantity-selector').forEach(function (selector) {
    selector.classList.toggle('active');
  });
});

THMDom.on("click", ".js-quantity-selector-option-btn", function (e) {
  e.preventDefault();
  THMDom.removeClass(
    THMDom.qsa('.js-quantity-selector-option'),
    "QuantitySelector__option--selected"
  );
  var option = this.closest('.js-quantity-selector-option');
  if (option) option.classList.add("QuantitySelector__option--selected");

  var value = this.dataset.value;

  THMDom.qsa('.js-quantity-input').forEach(function (input) {
    input.value = value;
  });
  THMDom.text(THMDom.qsa('.js-selected-quantity'), value);



  THMDom.removeClass(THMDom.qsa('.js-quantity-selector'), 'active');
});




THMDom.qsa('.PDPTabs__nav__item').forEach(function (navItem) {
  navItem.addEventListener('click', function (e) {
    var target = this.getAttribute('data-id');
    THMDom.removeClass(
      THMDom.qsa('.PDPTabs__nav__item'),
      'PDPTabs__nav__item--active'
    );
    THMDom.removeClass(
      THMDom.qsa('.PDPTabs__nav__item .PDPTabs__nav__underline'),
      'PDPTabs__nav__underline--active'
    );
    this.classList.add('PDPTabs__nav__item--active');
    THMDom.addClass(
      THMDom.qsa('.PDPTabs__nav__underline', this),
      'PDPTabs__nav__underline--active'
    );
    var panel = target ? document.getElementById(target) : null;
    if (panel) {
      THMDom.fadeIn(panel, 600);
      THMDom.hide(THMDom.siblings(panel, ".tab__content"));
    }
    e.preventDefault();
    e.stopPropagation();
    return false;
  });
});





function accordionResize() {
  if (THMDom.windowWidth() < 767) {

    // .accordion-item--keep-open opts out (kit "See It In Action").
    var accordion_items = THMDom.qsa(".accordion-item__custom:not(.accordion-item--keep-open)");
    if (accordion_items != null) {
      accordion_items.forEach(function (item) {
        THMDom.qsa(".accordion-item--product", item).forEach(function (panel) {
          panel.classList.remove("is-open");
          panel.removeAttribute('open');
        });
      });
    }
  }
}

/* Call the function */
accordionResize();



var faq_search = document.getElementById('faq-search');


if (faq_search != null) {

  faq_search.addEventListener('input', function () {
    const query = this.value.toLowerCase().trim();
    const titles = document.querySelectorAll('.faq__title');

    titles.forEach(title => {
      const faqItems = [];

      // Find the FAQ items below the current title
      let nextElement = title.nextElementSibling;
      while (nextElement && nextElement.classList.contains('faq-item')) {
        faqItems.push(nextElement);
        nextElement = nextElement.nextElementSibling;
      }

      // Check if any FAQ items match the search query
      let hasMatch = false;
      faqItems.forEach(item => {
        const titleElement = item.querySelector('summary span');
        const titleText = titleElement ? titleElement.textContent.toLowerCase() : '';

        if (query === '' || titleText.includes(query)) {
          item.style.display = ''; // Show matching item
          hasMatch = true;
        } else {
          item.style.display = 'none'; // Hide non-matching item
        }
      });

      // Show or hide the title based on whether there are matching FAQ items
      title.style.display = hasMatch ? '' : 'none';
    });
  });

}



THMDom.qsa('.tabs__nav__item').forEach(function (navItem) {
  navItem.addEventListener('click', function (e) {
    var target = this.getAttribute('data-id');
    THMDom.removeClass(THMDom.qsa('.tabs__nav__item'), 'active');
    this.classList.add('active');
    var panel = target ? document.getElementById(target) : null;
    if (panel) {
      THMDom.fadeIn(panel, 600);
      THMDom.hide(THMDom.siblings(panel, ".tab-content"));
    }
    e.preventDefault();
    e.stopPropagation();
    return false;
  });
});




     class THMLazyLoadingVideo extends HTMLElement {
                constructor() {
                    super();
                    this.isLoaded = false; // internal flag
                }

                loadVideo() {
                    if (this.isLoaded) return; // prevent duplicate loading
                    this.isLoaded = true;

                    if (this.dataVideoType === "local_video") {
                        const videoElement = this.querySelector("video");
                        const sourceElement = videoElement?.querySelector("source");
                        const videoSrc = sourceElement?.getAttribute("data-src");

                        if (videoSrc) {
                            sourceElement.setAttribute("src", videoSrc);
                            videoElement.load();
                            videoElement.muted = true;

                            videoElement.addEventListener("canplay", () => {
                                videoElement.play().catch(err => {
                                    console.warn("Autoplay failed:", err);
                                });
                            });
                        } else {
                            console.warn("Missing data-src on local video source.");
                        }
                    } else if (this.dataVideoType === "youtube" || this.dataVideoType === "vimeo") {
                        const iframe = this.querySelector("iframe");
                        const iframeSrc = iframe?.getAttribute("data-src");

                        if (iframe && iframeSrc) {
                            iframe.setAttribute("src", iframeSrc);
                        } else {
                            console.warn("Missing data-src on iframe.");
                        }
                    }
                }

                // Load only when the video is about to scroll into view. The
                // previous version also loaded on the first mousemove/scroll
                // and on a 10ms "fallback" timer, so an 18 MB 1080p video
                // below the fold started downloading during page load and
                // starved the product image (LCP) of bandwidth on mobile.
                execute() {
                    if (this.isLoaded || this.observer) return;

                    if (Shopify.designMode || !('IntersectionObserver' in window)) {
                        this.loadVideo();
                        return;
                    }

                    this.observer = new IntersectionObserver((entries) => {
                        if (!entries.some((entry) => entry.isIntersecting)) return;
                        this.observer.disconnect();
                        this.loadVideo();
                    }, { rootMargin: '300px 0px' });
                    this.observer.observe(this);
                }

                static get observedAttributes() {
                    return ["data-video-type", "data-video-id"];
                }

                set dataVideoType(val) {
                    this.setAttribute("data-video-type", val);
                }
                get dataVideoType() {
                    return this.getAttribute("data-video-type");
                }

                set dataVideoId(val) {
                    this.setAttribute("data-video-id", val);
                }
                get dataVideoId() {
                    return this.getAttribute("data-video-id");
                }

                attributeChangedCallback(name, oldValue, newValue) {
                    if (oldValue !== newValue) {
                        this.execute();
                    }
                }

                connectedCallback() {
                    this.execute();
                }

                disconnectedCallback() {
                    this.observer?.disconnect();
                    this.observer = null;
                }
            }

            customElements.define("thm-load-video", THMLazyLoadingVideo);






THMDom.on("click", "button.scroll_button", function (e) {

  THMDom.removeClass(THMDom.qsa("button.scroll_button"), "active");
  this.classList.add("active");
  var id = this.dataset.id;
  var scrollTarget = id ? THMDom.qs(id) : null;
  if (scrollTarget) {
    THMDom.scrollTopTo(THMDom.offsetTop(scrollTarget) - 310, 500);
  }
});



if (!customElements.get("collapsible-content")) {
  class CollapsibleContent extends HTMLElement {
    constructor() {
      super();
      this.disclosures = Array.from(this.querySelectorAll('details'));
      this.init();
    }

    init() {
      this.disclosures.forEach(disclosure => {
        const toggle = disclosure.querySelector('summary');
        const panel = toggle?.nextElementSibling;

        if (!panel) return;

        const hasTransition = window.getComputedStyle(panel).transitionDuration !== '0s';

        if (hasTransition) {
          toggle.addEventListener('click', (evt) => this.handleClick(evt, disclosure, panel));
          disclosure.addEventListener('transitionend', (evt) => this.handleTransitionEnd(evt, disclosure, panel));
        }
      });
    }

    handleClick(evt, currentDisclosure, currentPanel) {
      evt.preventDefault();

      const isOpen = currentDisclosure.open;

      if (isOpen) return; // Do not toggle if already open

      // Close all others
      this.disclosures.forEach(disclosure => {
        if (disclosure !== currentDisclosure && disclosure.open) {
          const panel = disclosure.querySelector('summary')?.nextElementSibling;
          if (panel) {
            this.close(disclosure, panel);
          }
        }
      });

      // Open current
      this.open(currentDisclosure, currentPanel);
    }

    handleTransitionEnd(evt, disclosure, panel) {
      if (evt.target !== panel) return;

      if (disclosure.classList.contains('is-closing')) {
        disclosure.classList.remove('is-closing');
        disclosure.open = false;
      }

      panel.removeAttribute('style');
    }

    addContentHeight(panel) {
      const height = panel.scrollHeight;
      if (height > 0) {
        panel.style.height = `${height}px`;
      } else {
        panel.style.height = null;
      }
    }

    open(disclosure, panel) {
      const height = panel.scrollHeight;
      if (height === 0) {
        disclosure.open = true;
        return;
      }

      panel.style.height = '0px';
      disclosure.open = true;

      requestAnimationFrame(() => {
        this.addContentHeight(panel);
      });
    }

    close(disclosure, panel) {
      const height = panel.scrollHeight;
      if (height === 0) {
        disclosure.open = false;
        return;
      }

      this.addContentHeight(panel);
      disclosure.classList.add('is-closing');

      requestAnimationFrame(() => {
        panel.style.height = '0px';
      });
    }
  }

  customElements.define('collapsible-content', CollapsibleContent);
}





document.addEventListener('DOMContentLoaded', () => {
  const overlayDivs = document.querySelectorAll('.overlay-details-button');

  overlayDivs.forEach(overlayDiv => {
    overlayDiv.addEventListener('click', (event) => {
      event.stopPropagation();

      const modalId = overlayDiv.getAttribute('data-modal-id');
      if (!modalId) return;

      const modal = document.getElementById(`modal-${modalId}`);
      if (!modal) return;

      // Show modal
      modal.style.display = 'block';

      // Add overflow hidden to closest .disclosure__panel
      const disclosurePanel = overlayDiv.closest('.disclosure__panel');
      if (disclosurePanel) {
        disclosurePanel.style.overflow = 'hidden';
      }

      // Add modal-open class to body
      document.body.classList.add('modal-open');

      // Close modal logic
      const closeBtn = modal.querySelector('.close-button');
      if (closeBtn) {
        closeBtn.onclick = () => {
          modal.style.display = 'none';

          if (disclosurePanel) {
            disclosurePanel.style.overflow = '';
          }

          // Remove modal-open class from body
          document.body.classList.remove('modal-open');
        };
      }

      window.onclick = (e) => {
        if (e.target === modal) {
          modal.style.display = 'none';

          if (disclosurePanel) {
            disclosurePanel.style.overflow = '';
          }

          // Remove modal-open class from body
          document.body.classList.remove('modal-open');
        }
      };
    });
  });
});


const sectionsToRenderNew = [
  {
    id: '#cart-counter',
    section: 'cart-counter',
    selector: '#shopify-section-cart-counter'
  },
  {
    id: '#CartDrawer-Body',
    section: 'cart-drawer',
    selector: '#shopify-section-cart-drawer #CartDrawer-Body'
  }
];



/**
 * <kit-siblings-list>
 * - "+" button toggles overflow swatches (beyond swatch_limit)
 * - Hover / focus on a swatch previews its name in the legend
 * Safe to load multiple times (guarded define).
 */
if (!customElements.get('kit-siblings-list')) {
  class KitSiblingsList extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('[data-kit-more]');
      this.overflowItems = this.querySelectorAll('[data-overflow]');
      this.valueEl = this.closest('fieldset')?.querySelector('[data-option-selected-value]');

      this.onToggle = this.toggle.bind(this);
      this.onPreview = this.preview.bind(this);
      this.onRestore = this.restore.bind(this);

      if (this.button) {
        this.button.addEventListener('click', this.onToggle);
      }

      if (this.valueEl) {
        this.addEventListener('mouseover', this.onPreview);
        this.addEventListener('focusin', this.onPreview);
        this.addEventListener('mouseleave', this.onRestore);
        this.addEventListener('focusout', this.onRestore);
      }
    }

    disconnectedCallback() {
      this.button?.removeEventListener('click', this.onToggle);
      this.removeEventListener('mouseover', this.onPreview);
      this.removeEventListener('focusin', this.onPreview);
      this.removeEventListener('mouseleave', this.onRestore);
      this.removeEventListener('focusout', this.onRestore);
    }

    get expanded() {
      return this.button?.getAttribute('aria-expanded') === 'true';
    }

    toggle() {
      this.setExpanded(!this.expanded);
    }

    setExpanded(expanded) {
      this.overflowItems.forEach((item) => {
        item.hidden = !expanded;
      });

      this.toggleAttribute('data-expanded', expanded);
      this.button.setAttribute('aria-expanded', String(expanded));

      const label = expanded ? this.button.dataset.labelLess : this.button.dataset.labelMore;
      if (label) this.button.setAttribute('aria-label', label);
    }

    preview(event) {
      const swatch = event.target.closest('[data-swatch-name]');
      if (!swatch || !this.contains(swatch)) return;
      this.valueEl.textContent = swatch.dataset.swatchName;
    }

    restore(event) {
      // Ignore focus moving between swatches inside the same list
      if (event.type === 'focusout' && this.contains(event.relatedTarget)) return;
      this.valueEl.textContent = this.valueEl.dataset.defaultValue || '';
    }
  }

  customElements.define('kit-siblings-list', KitSiblingsList);
}
